<template>
	<div class="mt-3">
		<!-- <template v-if="!loading"> -->
		<v-row>
			<v-col cols="12" class="py-0 py-sm-3">
				<div class="d-flex justify-end">
					<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
					<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showModalCari">
						<div class="d-flex">
							<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
							<div class="d-none d-sm-block">Cari</div>
						</div>
					</v-btn>
				</div>
			</v-col>
		</v-row>

		<div class="d-flex flex-wrap mr-n3">
			<template v-if="loading">
				<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="i in 5" :key="i">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
						<v-skeleton-loader width="100%" height="140px" type="image" class="rounded-xl"></v-skeleton-loader>
						<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
						<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
						<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
						<v-skeleton-loader width="100%" type="heading" class="mt-3 rounded-xl"></v-skeleton-loader>
					</v-card>
				</v-col>
			</template>
			<template v-else>
				<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="stockist in stockistList" :key="stockist.stockist_member_id">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100">
						<div class="btn-detail" v-if="false">
							<v-btn depressed x-small fab class="amber lighten-3">
								<v-icon color="grey darken-3">mdi-information-variant</v-icon>
							</v-btn>
						</div>
						<div class="rounded-xl overflow-hidden">
							<v-img eager height="140px" :src="stockist.stockist_image ? stockist.stockist_image : require('/public/assets/image/user-pict.jpg')"></v-img>
						</div>
						<div class="py-3">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<div class="font-size-10 product-name secondary--text" v-bind="attrs" v-on="on">{{ stockist.stockist_name }}</div>
								</template>
								<span>{{ stockist.stockist_name }}</span>
							</v-tooltip>
							<div class="font-size-10 font-weight-bold cl-primary">{{ stockist.stockist_code }}</div>
							<div class="pt-2 font-size-10 cl-grey">{{ stockist.stockist_city_name }}</div>
							<div class="pt-1 font-size-9 cl-grey">{{ stockist.stockist_province_name }}</div>
						</div>
						<v-btn block outlined depressed color="primary" class="mt-2 rounded-xl font-weight-bold text-capitalize" @click="showModalDetail(stockist)">Detail info</v-btn>
					</v-card>
				</v-col>
			</template>
		</div>

		<div class="mt-3" v-if="stockistList.length == 0 && !loading">
			<v-row>
				<v-col cols="12" sm="12" md="12">
					<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
						<NoData></NoData>
						<div class="px-3 pt-3 text-center secondary--text">Tidak ada data stokis yang dapat ditampilkan</div>
					</v-card>
				</v-col>
			</v-row>
		</div>

		<div v-if="stockistList.length > 0">
			<v-row justify="end" class="mt-4">
				<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
					<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="stockistPagination.total_page" @input="changePage"></v-pagination>
				</v-col>
				<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
					<div class=" font-size-10">Menampilkan {{ stockistPagination.total_display }} data dari total {{ stockistPagination.total_data }} data</div>
				</v-col>
				<v-col cols="4" sm="2" md="1">
					<v-select :items="limit_list" v-model="limit" hide-details dense class="" placeholder="Data" color="primary" item-color="primary" @input="changeLimit"></v-select>
				</v-col>
			</v-row>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
		<ModalDetail ref="modalDetail" :stockist="stokistSelected" @action="clearStockist"></ModalDetail>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';
import ModalDetail from './components/ModalDetail';

export default {
	components: {
		ModalCari, ModalDetail
	},
	props: {
		stokis_type: String,
	},
	data() {
		return {
			loading: true,
			btnLoading: false,
			stokistSelected: {},
			page: 1,
			limit: '10',
			limit_list: [ '10', '20', '50', '100' ],
			params: []
		}
	},
	computed: {
		...mapState('stokis', ['stockistList', 'stockistPagination']),
	},
	methods: {
		...mapActions('stokis', ['getStockistList', 'getMStockistList']),

		showModalCari() {
			this.$refs.modalCari.modalShow()
		},
		async showModalDetail(data) {
			if (data) {
				this.stokistSelected = await data
				setTimeout(() => {
					this.$refs.modalDetail.modalShow()
				}, 500);
			}
		},
		reset() {
			this.params = []
			this.page = 1
			this.getData()
			this.$refs.modalCari.reset()
		},
		cari(data) {
			this.params = []
			this.page = 1

			if(data.name.value)
				this.params.push(data.name)
			if(data.code.value)
				this.params.push(data.code)
			if(data.province.value)
				this.params.push(data.province)
			if(data.city.value)
				this.params.push(data.city)

			if (this.stokis_type == 'stokist') {
				this.getStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalCari.modalHide()
				})
			} else {
				this.getMStockistList(this.queryString({sort: 'stockist_member_id', dir: 'ASC', limit:this.limit, page: this.page, params: this.params})).then(() => {
					this.$refs.modalCari.modalHide()
				})
			}

			this.getLoadData()
		},
		changePage(page) {
			this.page = page
			this.getLoadData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getLoadData()
		},
		getLoadData() {
			this.loading = true
			const params = { limit: this.limit, page: this.page, params: this.params, sort: 'stockist_member_id', dir: 'ASC' }
			
			if (this.stokis_type == 'stokist') {
				this.getStockistList(params).then(() => {
					this.$refs.modalCari.modalHide()
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			} else {
				this.getMStockistList(params).then(() => {
					this.$refs.modalCari.modalHide()
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			}
		},
		getData() {
			this.loading = true
			this.limit = '10'
			this.page = 1
			const params = { limit:this.limit, page: this.page, params: this.params, sort: 'stockist_member_id', dir: 'ASC' }
			
			if (this.stokis_type == 'stokist') {
				this.getStockistList(params).then(() => {
					this.$refs.modalCari.modalHide()
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			} else {
				this.getMStockistList(params).then(() => {
					this.$refs.modalCari.modalHide()
					document.body.scrollTop = 0
					document.documentElement.scrollTop = 0
					this.loading = false
				})
			}
		},

		clearStockist() {
			this.stokistSelected = {}
			this.$refs.modalDetail.modalHide()
		}
	},
};
</script>